export const FORM_CONFIG = {
  birthdate: {
    autoComplete: 'bday',
    label: 'Patient’s date of birth',
    name: 'birthdate',
    shortName: 'dob',
  },
  zip: {
    autoComplete: 'shipping zip-code',
    label: 'Zip code',
    name: 'zip',
  },
  state: {
    defaultValue: '',
    label: 'Patient’s state',
    name: 'state',
  },
  submitButtonText: {
    default: 'Next',
    withoutTosCheckout: 'Agree and continue',
  },
  termsAndConditions: {
    label:
      'I agree to the Terms of Service, Privacy Policy and Telehealth Consent',
    labelStartTextWithoutTosCheckout:
      'By selecting the button below, you agree to the ',
    labelStartTextWithTosCheckout: 'I agree to the ',
  },
} as const;

export const EXCLUDED_STATES = ['IL'];

export const SUBMIT_BUTTON_DATA_TESTID = 'welcome-submit-button';
